import { useGoogleLogin } from "@react-oauth/google";
import React, { useEffect, useState } from "react";
import { Header } from "./Header.";
import Footer from "./Footer";
import "./Styles/inscription.css";
import LoginLoader from "../Images/login-filter.gif";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "universal-cookie";
import googleLogo from "../Images/google-logo.png";
import fbLogo from "../Images/fblogo.png";
import { LoginSocialFacebook } from "reactjs-social-login";
import moment from "moment/moment";

export const Inscription = () => {
  const [loading, setLoading] = useState(false);
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState([]);
  const cookies = new Cookies();

  const loginGoogle = useGoogleLogin({
    onSuccess: async (respose) => {
      try {
        const res = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${respose.access_token}`,
            },
          }
        );
        signup(
          "google",
          res.data.email,
          res.data.given_name,
          res.data.family_name,
          "",
          res.data.sub + "1KbA"
        );
      } catch (err) {
        console.log(err);
      }
    },
  });

  function loginFacebook(res) {
    signup(
      "facebook",
      res.data.email!==""? res.data.email : res.data.id + "@facebook.fr",
      res.data.last_name,
      res.data.first_name,
      "",
      res.data.id + "1KbA"
    );
  }

  const signup = (
    typeConnexion = "normal",
    emailAuth = "",
    firstnameAuth = "",
    lastnameAuth = "",
    phoneAuth = "",
    passwordAuth = ""
  ) => {
    setLoading(true);
    let data = {
      firstname: typeConnexion !== "normal" ? firstnameAuth : firstname,
      lastname: typeConnexion !== "normal" ? lastnameAuth : lastname,
      password: typeConnexion !== "normal" ? passwordAuth : password,
      email: typeConnexion !== "normal" ? emailAuth : email,
      isEnable: true,
      contact: typeConnexion !== "normal" ? phoneAuth : phone,
    };
    axios
      .post(process.env.REACT_APP_API_BASE_URL + "/api/users", data, {
        headers: {
          "x-api-token": process.env.REACT_APP_API_TOKEN,
        },
      })
      .then((a) => {

        let stringConnect =
          process.env.REACT_APP_API_BASE_URL +
          "/login?email=" +
          email +
          "&password=" +
          password;
        if (typeConnexion !== "normal") {
          stringConnect =
            process.env.REACT_APP_API_BASE_URL +
            "/login?email=" +
            emailAuth +
            "&password=" +
            passwordAuth;
        }
        axios
          .post(
            stringConnect,
            {},
            {
              headers: {
                "x-api-token": process.env.REACT_APP_API_TOKEN,
              },
            }
          )
          .then((b) => {

            
            if(b.data.mailConfirmedAt == null){
              cookies.set("user_temp", b.data, { path: "/" });
              
              toast.info(
                "Vous devez confirmer votre adresse email avant de continuer. Vous serez rediriger dans un instant !"
              );
              
              setTimeout(() => {
                window.location.href = "/MailConfirmation";
              }, 2500);
            }
            else {
              cookies.set("user", b.data, { path: "/", expires: moment().add(1, 'months').toDate() });

              toast.success(
                "Bienvenue dans la famille KabaaShop ! Vous serez rediriger dans un instant."
              );

              setTimeout(() => {
                window.location.href = "/";
              }, 2500);
            }

            setLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setLoading(false);
            if (
              error.response.data === "No User Found" ||
              error.response.data === "Password Invalid"
            ) {
              toast.error("Email ou mot de passe non correct !");
            } else {
              toast.error("Une erreur est survenue ! veuillez réessayer !");
            }
          });
          setLoading(false);
      })
      .catch((error) => {
        if (error.response.status == 422) {
          toast.error("Un compte a déjà été créé avec cette adresse !");
        } else {
          toast.error(
            "Une erreur est survenue ! Veuillez réessayer plus tard !"
          );
        }

        setLoading(false);
      });
  };

  const passwordConfirm = () => {
    let errors = [];

    if (password == "" && confirm == "") {
      return;
    }

    if (!password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/)) {
      errors.push(
        <li>
          Le mot de passe doit contenir au moins 1 lettre majuscule, 1 lettre
          minuscule et 1 chiffre et avoir au minimum 8 caractères
        </li>
      );
    }

    if (password !== confirm) {
      errors.push(<li>Les mots de passe ne correspondent pas</li>);
    }

    setPasswordErrors(errors);
    setIsPasswordValid(errors.length > 0 ? false : true);
  };

  document.title = "S'inscrire - KabaaShop";

  useEffect(() => {
    passwordConfirm();
  }, [password, confirm]);

  return (
    <>
      <ToastContainer />
      <Header />
      <div className='main-inscription'>
        <input type='checkbox' id='chk' aria-hidden='true'></input>
        <div className='signup'>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              signup();
            }}
          >
            <p className='signup-label'>Inscription</p>
            <div className='signup-row'>
              <input
                disabled={loading}
                className='signup-input'
                type='text'
                placeholder='Nom'
                required
                onChange={(e) => {
                  setLastname(e.target.value);
                }}
              />
              <input
                disabled={loading}
                className='signup-input'
                type='text'
                placeholder='Prénoms'
                required
                onChange={(e) => {
                  setFirstname(e.target.value);
                }}
              />
            </div>

            <div className='signup-row'>
              <input
                disabled={loading}
                className='signup-input'
                type='email'
                placeholder='Adresse Email'
                required
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
              <input
                disabled={loading}
                className='signup-input'
                type='phone'
                placeholder='N° Téléphone'
                required
                onChange={(e) => {
                  setPhone(e.target.value);
                }}
              />
            </div>

            <div className='signup-row'>
              <input
                disabled={loading}
                className='signup-input'
                type='password'
                placeholder='Mot de passe'
                required
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
              />
              <input
                disabled={loading}
                className='signup-input'
                type='password'
                placeholder='Confirmer le mot de passe'
                required
                onChange={(e) => {
                  setConfirm(e.target.value);
                }}
              />
            </div>
            <ul className='password-errors'>{passwordErrors}</ul>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <button
                disabled={loading || !isPasswordValid}
                className='signup-button'
              >
                <span
                  style={{ display: loading ? "none" : "block" }}
                  className='login-btn-text'
                >
                  S'inscrire
                </span>
                <span
                  style={{ display: loading ? "block" : "none" }}
                  className='login-btn-img'
                >
                  <img src={LoginLoader} alt="loading"/>
                </span>
              </button>
            </div>
          </form>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              disabled={loading}
              onClick={loginGoogle}
              style={{
                backgroundColor: "black",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "row",
                gap: "10px",
                padding: "10px",
                fontSize: "1em",
                boxSizing: "border-box",
                borderRadius: "10px",
                width: "275px",
              }}
            >
              <img
                src={googleLogo}
                style={{ height: "30px", aspectRatio: "1/1" }}
                alt='g-icon'
              />
              <span style={{ flex: 1, textAlign: "center" }}>
                Inscription avec google
              </span>
            </button>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <LoginSocialFacebook
              appId='591485485812656'
              onResolve={(response) => {
                loginFacebook(response)
              }}
              onReject={(response) => {
                toast.error("Une erreur est survenue ! veuillez réessayer !");
              }}
            >
              <button
                disabled={loading}
                // onClick={loginGoogle}
                style={{
                  backgroundColor: "black",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "row",
                  gap: "10px",
                  padding: "10px",
                  fontSize: "1em",
                  boxSizing: "border-box",
                  borderRadius: "10px",
                  width: "275px",
                }}
              >
                <img
                  src={fbLogo}
                  style={{ height: "30px", aspectRatio: "1/1" }}
                  alt='g-icon'
                />
                <span style={{ flex: 1, textAlign: "center" }}>
                  Inscription avec Facebook
                </span>
              </button>
              {/* <FacebookLoginButton /> */}
            </LoginSocialFacebook>
          </div>
          <p className='signup-p'>
            Déja un compte ?{" "}
            <a href='/connexion' className='signup-link'>
              Connectez-vous
            </a>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};
